


export module Cookie {

    export function read(name: string, default_val?: string): string | null {
        var result = new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)').exec(document.cookie);
        if (result) {
            return result[1]
        }
        if (default_val === undefined) {
            default_val = null;
        }

        return default_val;
    }

    export function read_json_array(key: string): any[] | null {
        var result_str: string = read(key);
        if (result_str) {
            try {
                let r = JSON.parse(result_str);
                if (Array.isArray(r)) {
                    return r;
                }
                else {
                    console.error(`read_json_array encountered a malformed array ${result_str}`)
                }
            } catch (e) {
                console.error(e)
            }
        }
        return [];
    }

    export function read_bool(key: string, default_val: boolean): boolean {

        let s_val: string = read(key);
        let rtn_val: boolean = default_val;
        if (s_val) {


            if (s_val === "1") {
                rtn_val = true;
            }
            else if (s_val.toLowerCase() === "true") {
                rtn_val = true;
            }
            else {
                rtn_val = false;
            }
        }
        return rtn_val;
    }


    export function write_bool(key: string, val: boolean) {
        let s_val: string = "false";
        if (val) {
            s_val = "true"
        }
        write(key, s_val);
    }
    export function write(name: string, value: string, days?: number) {
        if (!days) {
            days = 365 * 20;
        }

        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        var expires = "; expires=" + date.toUTCString();

        document.cookie = name + "=" + value + expires + "; path=/";
    }

    export function write_json(name: string, value: any, days?: number) {
        write(name, JSON.stringify(value), days)
    }

    export function remove(name: string) {
        write(name, "", -1);
    }

}


// WEBPACK FOOTER //
// ./src/ts/Cookies.ts